/*
 * -----------------------------------------------------------------------
 *  <copyright file="column/display.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { HC_COLORS_STANDARD, OpraColours } from 'interfaces/opra-chart.interface';
import ColumnChart from 'views/components/core/charts/column-chart';

const getColumn = ({ getRef, panelState, study, siteId, sites, isSortFieldSubjectPopulation }: any) => {
    if (
        !panelState?.panelData?.panelData?.length ||
        !panelState.panelData.panelData[0].columnForStudy ||
        (panelState.panelData.panelData[0].columnForStudy?.length === 1 &&
            !panelState.panelData.panelData[0].columnForStudy[0].category)
    )
        return <span>The preview cannot be displayed as data is not available</span>;

    const categories: string[] =
        Array.from(
            new Set((panelState.panelData.panelData[0].columnForStudy ?? []).map((p: any): string => p.category)),
        ) ?? [];

    const showNumSubjects: boolean =
        (panelState.chartConfig?.displayUnits ?? '') === 'PERCENT' && isSortFieldSubjectPopulation;

    const seriesData =
        !siteId || !panelState.chartConfig?.hideStudyColumns
            ? [
                  {
                      name: `${study?.studyNumber ?? 'Study'} (All Sites)`,
                      color: HC_COLORS_STANDARD[OpraColours.LightBlue],
                      values: categories.map(
                          (c: string) =>
                              panelState.panelData.panelData[0].columnForStudy
                                  ?.filter((p: any) => p.category === c)
                                  ?.reduce((prev: number, current: any) => prev + current.count, 0) ?? [],
                      ),
                      custom: {
                          numSubjects: showNumSubjects
                              ? panelState.panelData.panelData[0].flagFieldForStudy
                              : undefined,
                      },
                  },
              ]
            : [];

    if (siteId && panelState.panelData.panelData[0].columnForSites)
        seriesData.push({
            name: `Site: ${sites[siteId]?.Fields['Site.name']}`,
            color: HC_COLORS_STANDARD[OpraColours.DarkBlue],
            values: categories.map(
                (c: string) =>
                    panelState.panelData.panelData[0].columnForSites[siteId]
                        ?.filter((p: any) => p.category === c)
                        ?.reduce((prev: number, current: any) => prev + current.count, 0) ?? [],
            ),
            custom: {
                numSubjects: showNumSubjects ? panelState.panelData.panelData[0].flagFieldForSites[siteId] : undefined,
            },
        });

    return (
        <ColumnChart
            getRef={getRef}
            plotTitle={panelState.chartConfig.plotTitle}
            categories={categories}
            yAxisTitle={panelState.chartConfig.yTitle}
            xAxisTitle={panelState.chartConfig.xTitle}
            showLegend={panelState.hideLegend ? !panelState.hideLegend : true}
            series={seriesData.reverse()}
            hidePlotTitle={panelState.hidePlotTitle}
        />
    );
};

export { getColumn };
